<template>
  <div :style="`width: ${width};`">
  <div
    :class="`standard-step`"
    >
    <div
      :class="`
        standard-step-text
        t-rounded
        ${flat?'':'t-shadow'}
        mt-1 mb-1
        ${color?`${color} ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}`:''}
        `"
      :style="`${text_color?`color: ${text_color};`:''}`"
      >
      <v-icon
        v-if="drag_handle"
        class="cursor-grab"
        :color="text_color?text_color:'black'"
        @mouseenter="$emit('enableDragging')"
        @mousedown="dragging = true"
        @mouseup="$emit('disable_dragging'), dragging = false"
        @mouseleave="dragging?'':$emit('disableDragging')"
        >
        drag_handle
      </v-icon>
      <StandardOverflowButton
        v-else-if="step_type === 'materialsteps'"
        :value="step.status ? {value: step.status} : {value: 'open'}"
        :options="
          {value: [
            {value: 'open', icon: 'search', tooltip: 'Open'},
            {value: 'ordered', icon: 'shopping_cart', tooltip: 'Ordered'},
            {value: 'transport', icon: 'local_shipping', tooltip: 'Transport'},
            {value: 'onsite', icon: 'wb_iridescent', tooltip: 'Onsite'},
            {value: 'checked', icon: 'thumb_up', tooltip: 'Checked'},
            {value: 'done', icon: 'done', tooltip: 'Done'},
          ]}
        "
        @select-option="$emit('setStatus', $event)
        "
        />

        <!-- @button-clicked="setShowMilestones(false)"
        @select-option="setStatisticSettings({setting: $event.setting, value: $event.value}),
                        setShowMilestones(false)" -->
      <v-btn
        v-else
        class="ml-1 mr-1"
        icon
        height="24px"
        width="24px"
        @click="$emit('updateStepStatus', {done: !step.done})"
        :style="`${cursor?`cursor: ${cursor};`:''}`"
        >
      <v-icon
        :color="text_color?text_color:'black'"
        >
        {{step.done? 'check_circle_outline':'radio_button_unchecked'}}
      </v-icon>
      </v-btn>

      <!-- <div style="width: 100%"> -->
      <div style="width: 100%">
        <div style="display: flex; flex-direction: column; width: 100%; justify-content: space-between; flex-wrap: nowrap; white-space: nowrap">
        <textarea
          ref="standard-step-input-text"
          class="standard-step-input-text"
          :style="`
            cursor: ${cursor?cursor:readonly?'default':''};
            resize: ${resizable?'vertical':'none'}
            `"
          :readonly="readonly"
          :value="step.text"
          @input="$emit('inputStepValue', $event), resizeHeight()"
          @blur="blurInputField('text', $event)"
          @focus="focus.text = true"
          @keyup.esc="$refs['standard-step-input-text'].blur()"
          @keydown.enter="$refs['standard-step-input-text'].blur()"
        />
        <div v-if="(step_type === 'worksteps' || step_type === 'materialsteps' ) && location === 'taktplan_edit'" style="display: flex; flex-direction: row; width: 100%;">
          <slot name="workstep_linker"/>
          <StandardDataField
          width="30px"
          :value="step_type === 'worksteps' ? step.performance_value : step.conversion_factor"
          :text_color="text_color"
          :type="'number'"
          @changeValue="step_type === 'worksteps' ? $emit('changePerformanceValue', $event) : $emit('changeConversionFactor', $event)"
          />
          <div v-if="step_type === 'materialsteps'" style=" padding-left: 3px;display: flex; flex-direction: row">
          <StandardTextfield
          width="50px"
          :value="step.conversion_unit"
          placeholder="unit"
          :color="color"
          :textcolor="text_color"
          @changeValue="$emit('changeConversionUnit', $event)"
          />
          <div style="padding-left: 3px; height: 100%; padding-right: 3px"> / </div>
          </div>
          <div v-else style="padding-left: 3px; height: 100%; padding-right: 3px"> h / </div>
          <div :style="`width: ${step_type === 'worksteps' ? '130' : '90'}px; z-index: 1000`">
            <StandardDropdown
              width="100%"
              class="ma-1"
              :color="color"
              :textcolor="text_color"
              :value="getMassRelationShow(step_type, getMassName(step.mass_relation))"
              @changeValue="$emit('changeMassRelation', $event)"
              :options="expense_units"
            />
          </div>
        </div>

        <div v-if="(step_type === 'machinesteps') && location === 'taktplan_edit'" style="display: flex; flex-direction: row; width: 100%;">
          <StandardDataField
          width="30px"
          :value="step.booking_value"
          :text_color="text_color"
          :type="'number'"
          @changeValue="$emit('changeStepValue', { text: step.text, booking_value: parseFloat($event) })"
          />
          <StandardDropdown
            width="50%"
            class="ma-1"
            :color="color"
            :textcolor="text_color"
            :value="step.booking_unit"
            :options="booking_units"
            @changeValue="$emit('changeStepValue', { text: step.text, booking_unit: $event.value })"
          />
          <StandardDropdown
            width="70%"
            class="ma-1"
            :color="color"
            :textcolor="text_color"
            :value="step.type"
            :options="machinestep_types"
            @changeValue="$emit('changeStepValue', { text: step.text, type: $event.value })"
          />
        </div>
      </div>

      </div>
        <!--
      </div> -->
      <!-- <div
        v-if="step_type === 'worksteps' && location === 'taktplan' && step.mass_relation != ''" >
        <div v-if="step.elements.length != 0 && step.mass_relation != 'absolute'" style="white-space: nowrap; display: flex; flex-direction: row; text-align: center; width: 250px; justify-content: space-between">
          <div class="" style="padding-left: 3px; width: 80px; padding-right: 3px; border: solid 1.5px; border-radius: 3px"> {{stepElementsValue}} {{getMassUnit(step.mass_relation)}} </div>
          <div style=""> * {{step.performance_value}} h / {{getMassUnit(step.mass_relation)}} = </div>
          <div class="" style="overflow: hidden; width: 50px; padding-left: 3px; padding-right: 3px; border: solid 1.5px; border-radius: 3px; text-align: right"> {{stepElementsValue * step.performance_value}} h </div>
        </div>
        <div v-else-if="step.mass_relation != 'absolute'" style="overflow: hidden; width: 50px; padding-left: 3px; padding-right: 3px"> {{step.performance_value}} h /  {{step.mass_relation}}</div>
        <div v-else style="overflow: hidden; width: 50px; padding-left: 3px; padding-right: 3px; border: solid 1.5px; border-radius: 3px; text-align: right"> {{step.performance_value}} h </div> -->

        <!-- <div v-else style="width: 150px; margin-right: 1.5px; margin-top: 1.5px; padding-left: 3px; padding-right: 3px; white-space: nowrap; display: flex; flex-wrap: nowrap">   |  {{getMassName(step.mass_relation)}} </div> -->
      <!-- </div> -->
      <!-- <div
        v-if="step_type === 'materialsteps' && location === 'taktplan' && step.mass_relation != '' && step.conversion_unit != ''" >
        <div v-if="step.mass_relation != 'absolute'" style="white-space: nowrap; display: flex; flex-direction: row; text-align: center; width: 250px; justify-content: space-between">
          <div class="" style="padding-left: 3px; width: 80px; padding-right: 3px; border: solid 1.5px; border-radius: 3px"> {{stepElementsValue}} {{ step.conversion_unit }} </div>
          <div style=""> * {{step.conversion_factor}} {{ step.conversion_unit }} / {{getMassUnit(step.mass_relation)}} = </div>
          <div class="" style="overflow: hidden; width: 50px; padding-left: 3px; padding-right: 3px; border: solid 1.5px; border-radius: 3px"> {{stepElementsValue * step.conversion_factor}} {{ step.conversion_unit }} </div>
        </div>
        <div v-else-if="step.mass_relation != 'absolute'" style="overflow: hidden; width: 50px; padding-left: 3px; padding-right: 3px; border: solid 1.5px; border-radius: 3px"> {{step.conversion_factor}} {{ step.conversion_unit }} </div>
        <div v-else style="width: 150px; margin-right: 1.5px; margin-top: 1.5px; padding-left: 3px; padding-right: 3px; white-space: nowrap; display: flex; flex-wrap: nowrap"> {{step.conversion_factor}} {{ step.conversion_unit }}  |  {{getMassName(step.mass_relation)}} </div>
      </div> -->
      <!-- @keyup.enter="$refs['standard-step-input-text'].blur()" -->
      <!-- <v-btn
        icon
        height="24px"
        width="24px"
        @click="$emit('deleteStep')"
        >
        <v-icon
          v-if="!readonly && !add_step"
          color="black"
          >
          close
        </v-icon>
      </v-btn> -->
      <slot name="before-prepend-slot"/>
      <slot name="prepend-slot"/>
      <div>
      <StandardDeleteButton
        v-if="!readonly && !add_step"
        :zoom="1"
        @clickDelete="$emit('deleteStep')"
      />
      <!-- <v-btn icon>
        <v-icon>add</v-icon>
      </v-btn> -->
    </div>
      <v-icon
        class="cursor-pointer mr-2"
        v-if="clearable"
        small
        :color="text_color"
        @mousedown.prevent.stop="
          $emit('inputStepValue', {target: {value: ''}})
        "
        >
        clear
      </v-icon>
    </div>

    <div
      v-if="step_type !== 'worksteps' && step_type !== 'coststeps' && step_type !== 'materialsteps' && step_type !== 'machinesteps' && new_step_type !== 'material' && new_step_type !== 'machine'"
      :class="`
        standard-step-offset
        t-rounded
        ${flat?'':'t-shadow'}
        mt-1 mb-1
        ${color?`${color} ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}`:''}
        `"
      :style="text_color?`color: ${text_color}`:''"
      >
      <input
        ref="standard-step-input-offset"
        class="standard-step-input-offset"
        :style="readonly?'cursor: default':''"
        :readonly="readonly"
        :value="step.offset"
        type="number"
        @input="resizeHeight()"
        @blur="blurInputField('offset', $event)"
        @keyup.enter="$refs['standard-step-input-offset'].blur()"
        @focus="focus.offset = true"
        >
        <div class="standard-step-unit">TT</div>
    </div>
    <!-- material only: conversion factor -->
    <div
    v-if="new_step_type === 'material'"
    :class="`
      standard-step-offset
      t-rounded
      ${flat?'':'t-shadow'}
      mt-1 mb-1
      ${color?`${color} ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}`:''}
      `"
    :style="text_color?`color: ${text_color}`:''">
    <input
      ref="standard-step-input-offset"
      class="standard-step-input-offset"
      :style="readonly?'cursor: default':''"
      :readonly="readonly"
      :value="step.conversion_factor"
      type="number"
      @input="resizeHeight()"
      @blur="blurInputField('conversion_factor', $event)"
      @keyup.enter="$refs['standard-step-input-conversion_factor'].blur()"
      @focus="focus.conversion_factor = true"
      >
      <div class="standard-step-unit">CF</div>
    </div>
    <div
    v-if="new_step_type === 'material'"
    :class="`
      standard-step-offset
      t-rounded
      ${flat?'':'t-shadow'}
      mt-1 mb-1
      ${color?`${color} ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}`:''}
      `"
    :style="text_color?`color: ${text_color}`:''">
    <input
      ref="standard-step-input-offset"
      class="standard-step-input-offset"
      :style="readonly?'cursor: default':''"
      :readonly="readonly"
      :value="step.conversion_unit"
      type="text"
      @input="resizeHeight()"
      @blur="blurInputField('conversion_unit', $event)"
      @keyup.enter="$refs['standard-step-input-conversion_unit'].blur()"
      @focus="focus.conversion_unit = true"
      >
      <div class="standard-step-unit">CU</div>
    </div>
    <div
      v-if="step_type === 'coststeps'"
      :class="`
        standard-step-offset
        t-rounded
        ${flat?'':'t-shadow'}
        mt-1 mb-1
        ${color?`${color} ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}`:''}
        `"
      :style="text_color?`color: ${text_color}`:''"
      >
      <input
        ref="standard-step-input-cost"
        class="standard-step-input-cost"
        :style="readonly?'cursor: default':''"
        :readonly="readonly"
        :value="cost"
        type="number"
        @input="resizeHeight()"
        @blur="blurInputField('cost', $event)"
        @keyup.enter="$refs['standard-step-input-cost'].blur()"
        @focus="focus.cost = true"
        >
        <div class="standard-step-unit">€</div>
    </div>
  </div>
  <slot name="second-line"/>
  <slot name="third-line"/>
</div>
</template>
<script>
  import {
    mapState
  } from 'vuex';

  import StandardOverflowButton from '@/components/StandardComponents/StandardOverflowButton.component.vue'
  import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue'
  import StandardDropdown from '@/components/StandardComponents/StandardDropdown.component.vue'
  import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue'
  import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue'
  // import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue'
  export default {
    props: [
      'workpackage_id',
      'step_type',
      'step',
      'width',
      'value',
      'readonly',
      'flat',
      'resizable',
      'add_step',
      'drag_handle',
      'cursor',
      'text_color',
      'clearable',
      'color',
      'location',
      'new_step_type'
    ],
    components:{
      StandardDeleteButton,
      StandardDropdown,
      StandardDataField,
      StandardTextfield,
      StandardOverflowButton
      // StandardDataField
    },
    data: () => ({
      focus: {
        text: false,
        offset: false,
        cost: false,
      },
      text: "",
      offset: 0,
      cost: 0,
      dragging: false,
    }),
    mounted() {
      if (this.add_step) {
        this.$refs['standard-step-input-text'].focus();
      }
      if (this.step.text) {
        this.text = this.step.text
      }
      if (this.step.offset) {
        this.offset = this.step.offset
      }
      if (this.step.cost) {
        this.cost = this.step.cost
      }
      let  el = this.$refs['standard-step-input-text']
      el.style.height = "25px";
      if (this.$route.name === 'TaktPlanAddWorkPackageDetails') {
        setTimeout(function () {
          el.style.height = (el.scrollHeight)+"px";
        }, 600);
      } else {
        el.style.height = (el.scrollHeight)+"px";
      }
    },
    updated() {
      let  el = this.$refs['standard-step-input-text']
      el.style.height = "25px";
      el.style.height = (el.scrollHeight)+"px";
    },
    computed: {
      ...mapState('Ultra', [
        'expense_units',
        'booking_units',
        'machinestep_types'
      ]),
    },
    methods: {
      getMassRelationShow(step_type, mass_relation) {
        if (step_type === 'worksteps') {
          if (mass_relation.length > 13) {
            return mass_relation.substring(0, 13) + '...'
          }
          else {
            return mass_relation
          }
        }
        else if (step_type === 'materialsteps') {
          if (mass_relation.length > 5) {
            return mass_relation.substring(0, 5) + '...'
          }
          else {
            return mass_relation
          }
        }
        else {
          return ''
        }
      },
      getMassName(value) {
        let index = this.expense_units.findIndex(unit => unit.value === value)
        if (index === -1) {
          return '-';
        }
        return this.expense_units[index].text;
      },
      getMassUnit(value) {
        let index = this.expense_units.findIndex(unit => unit.value === value)
        if (index === -1) {
          return '-';
        }
        return this.expense_units[index].unit;
      },
      resizeHeight() {
        let  el = this.$refs['standard-step-input-text']
        el.style.height = "25px";
        el.style.height = (el.scrollHeight)+"px";
      },
      blurInputField(type, evt) {
        this[type] = evt.target.value
        this.focus[type] = false
        let self = this
        setTimeout(function () {
          if (!self.focus.text && !self.focus.offset) {
            if (self.text === '') {
              self.$emit('deleteStep')
            } else {
              if (self.step_type === 'worksteps') {
                if (self.text !== self.step.text || self.add_step) {
                  self.$emit('changeStepValue', {text: self.text})
                }
              } else if (self.step_type === 'coststeps') {
                if (self.text !== self.step.text || self.cost != self.step.cost) {
                  self.$emit('changeStepValue', {text: self.text, cost: parseInt(self.cost)})
                }
              } else if(self.new_step_type === 'material') {
                let update = {
                  text: self.text
                };
                if (self.conversion_unit) {
                  update.conversion_unit = self.conversion_unit;
                }
                if ( self.conversion_factor ) {
                  update.conversion_factor = parseFloat(self.conversion_factor);
                }
                self.$emit('changeStepValue', update);
              } else if(self.new_step_type === 'machine') {
                let update = {
                  text: self.text
                };
                self.$emit('changeStepValue', update);
              } else if (self.text !== self.step.text || self.offset != self.step.offset || self.add_step) {
                self.$emit('changeStepValue', {text: self.text, offset: parseInt(self.offset)})
              }
            }
          }
        }, 50);
      },
    }
  }
</script>
<style>
  .standard-step {
    display: flex;
  }
  .standard-step-text {
    display: flex;
    color: black;
    line-height: 25px;
    width: 100%;
    align-items: center;
  }
  .standard-step-offset {
    display: flex;
    color: black;
    line-height: 25px;
    width: 70px;
    align-items: center;
    justify-content: center;
  }
  .standard-step-unit {
    /* margin-left: -12px; */
    margin-right: 3px;
  }
  .standard-step-input-text {
    width: calc(100% - 52px);
    min-height: 25px;
    resize: none;
    overflow: hidden;
    justify-content: center;
  }
  .standard-step-input-offset {
    width: 100%;
    min-height: 25px;
    resize: none;
    overflow: hidden;
    justify-content: center;
    text-align: right;
    z-index: 2;
  }
  .standard-step-input-cost {
    width: 100%;
    min-height: 25px;
    resize: none;
    overflow: hidden;
    justify-content: center;
    text-align: right;
    z-index: 2;
  }
  .standard-step-input-performance-value{
    width: 50%;
    min-height: 25px;
    resize: none;
    overflow: hidden;
    text-align: right;
  }
  .nervige-row {
    width: calc(100% - 76px);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    white-space: nowrap;
    gap: 5px;
    padding-right: 76px ;
    align-items: center
  }
  .standard-step-input-text:focus {
    outline: none;
  }
  .standard-step-input-offset:focus {
    outline: none;
  }
  .standard-step-input-cost:focus {
    outline: none;
  }
  .standard-step-input-text::placeholder {
    font-style: italic;
    color: #424242
  }
  .standard-step-input-offset::placeholder {
    font-style: italic;
    color: #424242
  }
  .standard-step-input-cost::placeholder {
    font-style: italic;
    color: #424242
  }
</style>
